export default {
  buyingGuides: {
    id: 'landing_buying_guides',
    defaultMessage: 'Read our guides',
  },
  relatedComparePagesTitle: {
    id: 'plp_related_compare_pages_title',
    defaultMessage: 'Our recent comparisons',
  },
  prevSlideText: {
    id: 'buying_guide_slider_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'buying_guide_slider_next_slide',
    defaultMessage: 'Display next slide',
  },
  metaDescription: {
    id: 'landing_meta_description',
    defaultMessage:
      'Find the best deals on the refurbished {productType}. Up to 70% off compared to new ✌ Free delivery ✅ Cheap {productType} ✅ {warrantyDuration} year warranty ✅ {coolingOffDays}-day money-back guarantee',
  },
  seoTitle: {
    id: 'landing_seo_title',
    defaultMessage: '{title} - Page {pageNumber}',
  },
  resultsCount: {
    id: 'landing_page_filters_products_new_plural',
    defaultMessage: `{total, plural,
      one {# product}
      other {# products}
    }`,
  },
  qualityAssuranceFee: {
    id: 'landing_page_price_quality_assurance_fee',
    defaultMessage: 'Quality Assurance Fees apply (starting at £0.99)',
  },
  blackFridayStartLabel: {
    id: 'plp_black_friday_start_countdown_text',
    defaultMessage: 'Cheaper tech. Smaller footprint. Bigger grin in...',
  },
  blackFridayEndLabel: {
    id: 'plp_black_friday_end_countdown_text',
    defaultMessage: "Black Friday's not over - but il will be...",
  },
  e2eTranslationCheck: {
    id: 'product-list-page-e2e-translation-check',
    defaultMessage: 'Product list page e2e translations check default message',
  },
}
